import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./constants/theme";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { registerImageCacheSW } from "./utils/registerImageCache";
import axios from "axios";
import { incrementRequests, decrementRequests } from "./utils/requestTracker";

registerImageCacheSW();

// Track in-flight axios requests so the impression queue knows when the
// network is idle and won't compete with data API calls.
axios.interceptors.request.use((config) => {
  incrementRequests();
  return config;
});
axios.interceptors.response.use(
  (response) => { decrementRequests(); return response; },
  (error)    => { decrementRequests(); return Promise.reject(error); }
);

const stripePromise = loadStripe(
  "pk_test_51OtOPQI0AB3MJMJk0pGT9NQFDoEkVf4fx1dbQn6Dl6F3vkwYQh9tQIf94eggqnnVAFNttWUWRDTMF0dVgZ1Zkjt500qVksy22o"
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
        <Toaster />
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
